import { Grid, Box, Link, ListItem, styled } from '@mui/material';
import { ReactNode } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Item, WsTypography, WsTypoVariants, WsTypoColors, WsColors } from 'wisestep-base';

const IndexItem = styled(ListItem)(() => ({
  cursor: 'pointer',
  '&.Mui-selected': {
    backgroundColor: 'inherit',
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'inherit',
  },
  '&.MuiTypography-root': {
    backgroundColor: 'white',
  },
}));
export interface ISubOption {
  label: string;
  icon?: ReactNode;
  url?: string;
  count?: number | string;
}

export interface IOption {
  label: string;
  icon?: ReactNode;
  subOptions?: ISubOption[];
  url?: string;
  count?: number | string;
  visible?: boolean;
}

export interface ITeamsOptionsProps {
  index?: string;
  options: IOption[];
  getSelectedOption?: (arg1: number) => void;
  getSelectedSubOption?: (arg1: number) => void;
  bgColorforlist?: boolean;
}

const TeamsOptions = ({ index, options }: ITeamsOptionsProps) => {
  const location = useLocation();

  const URLBasedOptions = (option: IOption) => (
    <Link component={RouterLink} to={option.url ?? './'} underline="none" color="inherit">
      <IndexItem
        selected={location.pathname === option.url}
        secondaryAction={<WsTypography>{option.count ?? ''}</WsTypography>}
        style={{
          backgroundColor: location.pathname === option.url ? WsColors.White : 'inherit',
          borderRadius: '5px',
        }}
      >
        <WsTypography
          variant={WsTypoVariants.BODY1}
          color={location.pathname === option.url ? WsTypoColors.PRIMARY : WsTypoColors.WHITE}
          cursor="pointer"
          bold
        >
          {option.label}
        </WsTypography>
      </IndexItem>
    </Link>
  );

  return (
    <Item sx={{ backgroundColor: WsColors.TheBlues900 }}>
      {index && (
        <Box>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.TERTIARY}>
            {index}
          </WsTypography>
        </Box>
      )}
      {options.map(
        (option, i) =>
          (option.visible || option.visible === undefined) && (
            <Grid key={i} item xs={12}>
              {option.url && URLBasedOptions(option)}
            </Grid>
          )
      )}
    </Item>
  );
};

export default TeamsOptions;
